export default "__VITE_ASSET__CC1uGmL$__"